import React from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import GetEvent from '../../services/getEvent';
import GetCompanies from '../../services/getCompanies';
import GetInvestorsReport from '../../services/getInvestorsReport';
import GetIntermediaries from '../../services/getIntermediaries';
import GetInvestorsCompanyReport from '../../services/getInvestorsCompanyReport';
import GetInvestorsCountryReport from '../../services/getInvestorsCountryReport';
import GetMeetings from '../../services/getMeetings';
import Cookies from 'universal-cookie';
import GetCompaniesExcel from '../../services/getCompaniesExcel';
import Constants from "../consts";
import moment from 'moment';
import Investors from '../../pages/stats/Stats';


export default async function generateReportAdminExcel(){

    const cookies = new Cookies();
    var token = cookies.get('token', { path: '/' });
    var uname = cookies.get('username', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });

    var event = await GetEvent(uname, token, currentEventId);

    var companies = await GetCompanies(uname, token, currentEventId);
    var investors = await GetInvestorsReport(uname, token, currentEventId);
    var investorsCompanies = await GetInvestorsCompanyReport(uname, token, currentEventId);
    var investorsCountries = await GetInvestorsCountryReport(uname, token, currentEventId);
    var meetings = await GetMeetings(uname, token, currentEventId);
    var intermediaries = await GetIntermediaries(uname, token, currentEventId, 'investor');

    var startDate = moment(event.startDate, "DD/MM/yyyy");
    var endDate = moment(event.endDate, "DD/MM/yyyy");


    var eventDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      eventDays.push(moment(tempDate));
      tempDate = tempDate.add(1, 'd');
    }

    var mtgPerPerson = [];
    var mtgPerFund = [];
    var mtgPerIntermediary = [];
    var fundGeo = [];
    var investorGeo = [];
    var mtgPerCompany = [];


    mtgPerPerson.push(['', '<b>' + event.eventName + '</b>', event.startDate + ' - ' + event.endDate, '', '']);

    mtgPerPerson.push(['', '<b style="background: red;">INVESTMENT FUND</b>', '<b>INVESTOR</b>', '<b>COUNTRY</b>', '<b>MTG per PERSON</b>']);

    var meetingTotal = 0;
    var meetingTotal2 = 0;
    
    var investorIndex = 0;
    investors.forEach((investor, index) => {
      if (investor.isAnalyst == 1) return;
      investorIndex++;

      var meetingCount = 0;
      meetings.forEach(m => {
        m.investors.forEach(i => {
          if (i.isAnalyst == 1) return;
          if (i.id == investor.id)
            meetingCount++;
        });
      });
      meetingTotal += meetingCount;
      mtgPerPerson.push([investorIndex, '<b>' + investor.company + '</b>', investor.name, investor.country, meetingCount]);
    })

    mtgPerPerson.push(['','','','','']);
    mtgPerPerson.push(['','','', '<b>Total</b>',meetingTotal]);

    mtgPerFund.push(['', '<b>' + event.eventName + '</b>', event.startDate + ' - ' + event.endDate]);
    mtgPerFund.push(['', '<b style="background: red;">INVESTMENT FUND</b>', '<b>MTG per FUND</b>']);

    meetingTotal = 0;
    investorsCompanies.forEach((investor, index) => {
      var meetingCount = 0;
      meetings.forEach(m => {
        var bPresent = false;
        m.investors.forEach(i => {
          if (i.isAnalyst == 1) return;
          if (i.company.trim() == investor.company.trim())
            bPresent = true;
        });
        if (bPresent == true)
          meetingCount++;
      });
      meetingTotal += meetingCount;

      mtgPerFund.push([index+1, '<b>' + investor.company + ' - ' + investor.brokerId + '</b>', meetingCount]);
    })

    mtgPerFund.push(['', '', '']);
    mtgPerFund.push(['', '<b>Total</b>', meetingTotal]);

    meetingTotal = 0;
    meetingTotal2 = 0;

    mtgPerIntermediary.push(['<b>' + event.eventName + '</b>', event.startDate + ' - ' + event.endDate, '']);
    mtgPerIntermediary.push(['<b style="background: red;">INTERMEDIARY</b>', '<b>Sum of MEETINGS REQUESTS per Company</b>', '<b>Sum of MEETINGS REQUESTS per Person</b>']);

    intermediaries.forEach((broker, index) => {
      var meetingCount = 0;
      var meetingCountPerson = 0;
      meetings.forEach(m => {
      
        investorsCompanies.forEach((investorCompany, index) => {

          var companyFound = false;
          m.investors.forEach(i => {
            if (i.isAnalyst == 1) return;
            if (i.brokerId == broker.id && i.company.trim() == investorCompany.company.trim()){
              meetingCountPerson++;
              companyFound = true;
            }
          });
          if (companyFound == true)
            meetingCount++;

        });

      });

      meetingTotal += meetingCount
      meetingTotal2 += meetingCountPerson

      mtgPerIntermediary.push(['<b>' + broker.name + '</b>', meetingCount, meetingCountPerson]);
    })

    mtgPerIntermediary.push(['', '', '']);
    mtgPerIntermediary.push(['<b>Total</b>', meetingTotal, meetingTotal2]);

    meetingTotal = 0;
    meetingTotal2 = 0;

    investorGeo.push(['<b>COUNTRY</b>', '<b>Count of INVESTORS</b>']);
    investorsCountries.forEach((c, index) => {
      var meetingCount = 0;
      investors.forEach(i => {
        if (i.isAnalyst == 1) return;
        if (i.country == c.country)
        meetingCount++;
      });

      meetingTotal += meetingCount;
      investorGeo.push(['<b>' + c.country + '</b>', meetingCount]);
    })

    investorGeo.push(['', '']);
    investorGeo.push(['<b>Total</b>', meetingTotal]);


    meetingTotal = 0;
    meetingTotal2 = 0;

    mtgPerCompany.push(['<b>COMPANY</b>', '<b>MTG INVESTMENT FUND</b>', '<b>MTG ANALYSTS</b>']);
    companies.forEach((c, index) => {
      var fundArray = [];
      var analystsArray = [];
      meetings.forEach(m => {
        if (m.company_id != c.id) return;
        m.investors.forEach(i => {
          if (i.isAnalyst == 1){
            if (analystsArray.includes(i.name.trim()) == false)
              analystsArray.push(i.name.trim());
          }
          else {
            if (fundArray.includes(i.company.trim()) == false)
              fundArray.push(i.company.trim());
          }
            
        });
      });
      meetingTotal += fundArray.length;
      meetingTotal2 += analystsArray.length;
      mtgPerCompany.push([c.name, fundArray.length, analystsArray.length]);
    })

    mtgPerCompany.push(['', '', '']);
    mtgPerCompany.push(['<b>Total</b>', meetingTotal, meetingTotal2]);


    var json = {
      tabs : [
        {
          name: 'Investors - MTG per person',
          data: mtgPerPerson
        },
        {
          name: 'Inv. Funds - MTG per Fund',
          data: mtgPerFund
        },
        {
          name: 'MTG per INTERMEDIARY',
          data: mtgPerIntermediary
        },
        {
          name: 'Investor Geographies',
          data: investorGeo
        },
        {
          name: 'MTG per Company',
          data: mtgPerCompany
        }

      ]
    };

    await GetCompaniesExcel(uname, token, JSON.stringify(json), 'report');
    window.location.href= Constants.mainUrl+'apis/files/report.xlsx';

}